import React, { useState } from 'react';
import SubmitButton from '../submit-button/submit-button';
import InputField from '../input-field/input-field';
import AuthPanel from '../auth-panel/auth-panel';

export default function ForgotPassword() {
  const [continueButtonDisabled, setContinueButtonDisabled] = useState(true);

  function onChange(e) {
    const isEmpty = e.target.value === '';
    setContinueButtonDisabled(isEmpty);
  }

  return (
    <AuthPanel message='Acontece com todo mundo! Um link para uma nova senha será enviado para o seu email.'>
      <div className='login-fieldset' style={{ marginTop: '40px' }}>
        <InputField
          type='text'
          inputId='emailConfirm'
          label='confirme seu email'
          placeholder='insira seu email'
          validationMessage={
            continueButtonDisabled
              ? 'email não cadastrado, tente novamente'
              : ''
          }
          onChange={onChange}
        />
      </div>
      <div className='login-button'>
        <SubmitButton
          variant='primary'
          buttonStyle={{ width: '288px' }}
          value='receber link'
          disabled={continueButtonDisabled}
        />
      </div>
    </AuthPanel>
  );
}
